module.exports = __webpack_public_path__ + "img/linggan.7b69d746.gif";